<template>
  <div>
    <Ibox v-if="data.status == 'success'" :back="'true'" :titulo="'Editar Area'">
      <FormGroup
        cols="6"
        :is_loading=loading
        label="Nombre">
        <input type="text" class="form-control" v-model="area.desc_area">
      </FormGroup>
      <FormGroup
        cols="6"
        :is_loading=loading
        label="Habilitado">
        <v-select 
          v-model="area.habilitado"
          :clearable=false
          :reduce="habilitado=>habilitado.v"
          :options="[{v:'S',label:'Si'},{v:'N',label:'No'}]">
        </v-select>
      </FormGroup>
      <b-col v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="!editing" variant="primary" v-on:click="editarArea()">Editar</b-button>
        <b-button v-else variant="primary"><Loading :size="'1'" :text="'Editando area'"/></b-button>
      </b-col>
    </Ibox>
    <Ibox v-else :back="'true'" :titulo="'Editar area'">
      <b-col cols="12">
        <h4>{{ data.msg }}</h4>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {sucursalService} from "@/services";
import {utils} from "@/helpers";

export default {
  name: 'SucursalAreaEditar', 
  data(){
    return {
      data: {
        status:"success"
      },
      utils,
      loading: true,
      editing: false,
      area: utils.jd64(this.$route.params.area),
    }
  },
  mounted(){
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Configuración / Sucursal ' + this.area.desc_sucursal + ' / Area ' + this.area.desc_area+ ' / Editar');
  },
  methods: {
    cargarDatos(){
      sucursalService.getSucursalAreas({
        id_cliente:this.$store.state.usuario.id_cliente,
        habilitado:this.area.habilitado,
        id_sucursal:this.area.id_sucursal,
        id_area:this.area.id_area
      }).then(data => {
        this.data = data;

        if(data.status == "success"){
          this.sucursal = data.data[0];
        }
        this.loading = false;
      });
    },
    editarArea(){
      if(this.area.desc_area == null || this.area.desc_area == ''){
        utils.alerta({msg:'Faltan campos obligatorios',status:'warning'});
      }else{
        this.editing = true;

        sucursalService.putSucursalArea(this.area).then(respuesta => {
          utils.alerta(respuesta);
          this.editing = false;

          if(respuesta.status == "success"){
            //socket
            this.$socket.emit('prevn', 
              {
                id_cliente:this.$store.state.usuario.id_cliente,
                dispatch:'usuario/sincronizar'
              }
            );

            this.$router.go(-1);
          }
        });
      }
      
    },
  }
}
</script>

<style scoped>
</style>
